import { Settings } from "../Settings/Settings";
import { ArchipelagoConnection, ArchipelagoConnectionEvents, type ArchipelagoConnectionStatus } from "./Connection";

let connection: ArchipelagoConnection | undefined;

/** Returns true if the player has configured enough for the client to attempt a connection. */
export function isArchipelagoConfigured(): boolean {
  return (
    Settings.ArchipelagoPort > 0 && Settings.ArchipelagoPort <= 65535 && Settings.ArchipelagoSlotName.trim() !== ""
  );
}

/**
 * Closes any existing Archipelago connection and starts a new one.
 *
 * Does nothing if the client is disabled (port 0) or has no slot name, so players who do not use
 * Archipelago never open a socket.
 */
export function newArchipelagoConnection(): void {
  if (connection) {
    connection.disconnect();
    connection = undefined;
  }

  if (!isArchipelagoConfigured()) {
    ArchipelagoConnectionEvents.emit("Offline");
    return;
  }

  connection = new ArchipelagoConnection();
  void connection.connect();
}

export function getArchipelagoConnectionStatus(): ArchipelagoConnectionStatus {
  return connection?.status ?? "Offline";
}
